import React from 'react'
import CompanyOverview from '../Explore/CompanyOverview'

function Companyoverview() {
  return (
    <>
        <CompanyOverview />
    </>
  )
}

export default Companyoverview
